export default "__VITE_ASSET__BUdPugnj__"